import {Actions} from "profile/actions";
import {IProfile, IUserStatus} from "StateInterface";
import {ILatestStatus} from "profile/interface";

export interface IState  {
    userStatus: IUserStatus;
    profile: IProfile;
    paanduProfile: IProfile;
    latestStatus: ILatestStatus;
}

const defaultState: IState = {
    userStatus: null,
    profile: null,
    paanduProfile: null,
    latestStatus: null,
};

export default function profileInfo(state = defaultState, action) {
    switch (action.type) {
        case Actions.SET_PROFILE_INFO:
            return {
                ...state,
                userStatus: action.body,
            };
        case Actions.SET_PAANDU_PROFILE:
            return {
                ...state,
                paanduProfile: action.body,
            };
        case Actions.SET_LAM_PROFILE:
            return {
                ...state,
                profile: action.body,
            };
        case Actions.SET_LATEST_APPLICATION_STATUS:
            return {
                ...state,
                latestStatus: action.body,
            };
        case Actions.CLEAR_PROFILE_INFO:
            return defaultState;
        default:
            return state;
    }
}
